import React from "react";
import { SocialIcon } from "react-social-icons";

type ScoreShareDetails = {
  topCandidate: string;
  /**
   * The percentage of the quiz that matches the top candidate.
   * This is a number between 0 and 100.
   */
  matchScore: number;
};

export const SocialButton: React.FC<{
  url: string;
  ariaLabel?: string;
  customSize?: string;
}> = ({ url, ariaLabel, customSize }) => (
  <SocialIcon
    className="mr-2"
    target="_blank"
    rel="noopener noreferrer"
    aria-label={ariaLabel || "Share this link"}
    bgColor="#FFFFFF" // The City Reporter White
    fgColor="#292929" // The City Reporter Dark Grey
    style={{ width: customSize || "1.2rem", height: customSize || "1.2rem" }}
    url={url}
  />
);

export const SocialShareButtons: React.FC<{
  /**
   * Details on the matching score with the top candidate — only present if the user has completed the quiz.
   */
  results?: ScoreShareDetails;
}> = () => {
  const shareUrl = `${process.env.REACT_APP_DOMAIN}${process.env.REACT_APP_SLUG}/`;
  return (
    <div className="eyebrow mb-2">
      <SocialButton
        url={`https://x.com/intent/post?text=${shareUrl}`}
        ariaLabel="Share on X"
      />
      <SocialButton
        url={`https://bsky.app/intent/compose?text=${shareUrl}`}
        ariaLabel="Share on Bluesky"
      />
      <SocialButton
        url={`mailto:?subject=${process.env.REACT_APP_SOCIAL_HEADLINE}&body=${shareUrl}`}
        ariaLabel="Share via Email"
      />
    </div>
  );
};
